const routes = [
  {
    path: 'tableheadingsticky',
    name: 'tableheadingsticky',
    component: () => import(/* webpackChunkName: "tableheadingsticky" */ '@/modules/tableheadingsticky/index.vue')
  },
  {
    path: 'tableheadingstickycode',
    name: 'tableheadingstickycode',
    component: () => import(/* webpackChunkName: "tableheadingstickycode" */ '@/modules/tableheadingsticky/code.vue')
  },
];

export default routes;